var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.hideNavbar)?_c('Navbar'):_vm._e(),_c('router-view'),_c('AppFooter',{attrs:{"hideSolutionFooter":_vm.hideSolutionFooter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }